import { createContext, useReducer } from "react";

/**
 * Use Context and Use Reducer
 *
 * The Context allows us to create something global that can be accessed all over the application or the component
 * The contect also gives use the provider which provides the data needed
 *
 * The useReducer is like a useState but with a dispatch(setState) and the Reducer function
 *
 * Inside the dispatch, we pass {type:'ACTION to be done', payload:[Data to be set]}
 *
 * The reducer function takes a state(The initial state) and the action which is the dispatch(type,payload)
 *
 * Finally we pass the state and disptach to the Provider as a value object
 */
export const ResultsContext = createContext();

export const resultsReducer = (state, action) => {
  switch (action.type) {
    case "GET_RESULTS":
      return {
        results: action.payload,
      };
    case "ADD_RESULT":
      return {
        /**
         * action.payload => New result
         * state.results => Contains the previous results
         * ...state.proggrammes => Spread the previous results
         */
        results: [action.payload, ...state.results],
      };
    case "DELETE_RESULT":
      return {
        /**
         * action.payload => New result
         * state.results => Contains the previous results
         * ...state.results => Spread the previous results
         *
         * Since payload for this has only the id, then we use the id to filter
         */
        results: state.results.filter((result) => result.id !== action.payload),
      };
    case "EDIT_RESULT":
      return {
        // ...state,
        results: state.results.map((result) =>
          result.id === action.payload.id ? action.payload : result
        ),
      };

    default:
      return state;
  }
};

export const ResultsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(resultsReducer, {
    results: null,
  });

  return (
    <ResultsContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ResultsContext.Provider>
  );
};
